import React, { useRef, useState } from "react";
import { color_red_default } from "../../../../../constants/colors";
import { Link } from "../../../../styled/TextComponents";

import axios from "axios";
import { InfinitySpin } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import Config from "../../../../../Config";
import { updateUser } from "../../../../../store/UserSlice";
import { MODAL_Z_INDEX_NESTED } from "../../../../../constants/layers";
import { useWindowDimensions } from "../../../../../utils";
import DeleteIcon from "../../../../icons/DeleteIcon";
import EditIcon from "../../../../icons/EditIcon";
import ModalQuestion from "../../../ModalQuestion";
import ModalSimple from "../../../ModalSimple";
import { styles } from "./Styles";
import { useI18n } from "../../../../../i18n/I18nProvider";

export const ProfileImageUpdating = () => {
  const { t } = useI18n();
  const [imageDeleting, setImageDeleting] = useState(false);
  const { height: screenHeight, width: screenWidth } = useWindowDimensions();
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const inputFile = useRef(null);
  const [isWaiting, setIsWaiting] = useState(false);
  const [waitingText, setWaitingText] = useState(t("обновление"));
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({
    type: "info",
    h2: "",
    p: "",
    buttonText: t("Хорошо"),
  });

  function toggleImageDeleting() {
    if (user.image === window.location.origin + "/no_profile_icon.png") {
      alert(t("Для вашего профиля не установлено изображения. Нечего удалять."));
      return;
    }
    setImageDeleting(true);
  }

  function uploadNewImage() {
    inputFile.current.click();
  }

  function imageSelectedHandler(e) {
    setIsWaiting(true);
    setWaitingText(t("загрузка"));
    let fileObj = e.target.files[0];
    // Проверка размера файла (не больше 1024 КБ)
    if (fileObj.size > 1024 * 1024) {
      setModalContent({
        type: "alert",
        h2: t("Ошибка загрузки"),
        p: t("Размер файла не должен превышать 1 МБ, разрешение — 1000×1000 px. Если ваше изображение не соответствует требованиям, уменьшите его через любой онлайн‑сервис (например, tinypng.com) и загрузите снова."),
        buttonText: t("Закрыть"),
      });
      setModalOpen(true);
      setIsWaiting(false);
      return;
    }

    // Проверка разрешения изображения (не больше 1000x1000)
    const img = new window.Image();
    const objectUrl = URL.createObjectURL(fileObj);
    img.src = objectUrl;
    img.onload = function () {
      if (img.width > 1000 || img.height > 1000) {
        setModalContent({
          type: "alert",
          h2: t("Ошибка загрузки"),
          p: t("Размер файла не должен превышать 1 МБ, разрешение — 1000×1000 px. Если ваше изображение не соответствует требованиям, уменьшите его через любой онлайн‑сервис (например, tinypng.com) и загрузите снова."),
          buttonText: t("Закрыть"),
        });
        setModalOpen(true);
        setIsWaiting(false);
        URL.revokeObjectURL(objectUrl);
        return;
      }
      // Продолжить обработку, если все проверки пройдены
      const formData = new FormData();
      formData.append("file", fileObj, fileObj.name);

      const headers = { "Content-Type": "multipart/form-data" };

      axios
        .post(Config.BACKEND_ADDR + "/cloud/put_file", formData, {
          headers: headers,
        })
        .then((res) => {
          axios
            .patch(Config.BACKEND_ADDR + `/auth/user/${user.id}`, {
              image: res.data.file_id,
            })
            .then(() => {
              dispatch(
                updateUser({
                  image: res.data.file_id,
                }),
              );
              setIsWaiting(false);
              URL.revokeObjectURL(objectUrl);
            })
            .catch(() => {
              setIsWaiting(false);
              console.error("Error updating user image:", e);
              URL.revokeObjectURL(objectUrl);
            });
        })
        .catch(() => {
          setIsWaiting(false);
          URL.revokeObjectURL(objectUrl);
        });
    };
    img.onerror = function () {
      alert(t("Ошибка при загрузке изображения."));
      setIsWaiting(false);
      URL.revokeObjectURL(objectUrl);
    };

    e.target.value = null; // Сброс значения input, чтобы можно было выбрать тот же файл снова, если нужно
    return;
  }

  function handleDeleteImage() {
    setWaitingText(t("удаление"));
    setIsWaiting(true);
    setImageDeleting(false);
    axios
      .patch(Config.BACKEND_ADDR + "/cloud/delete_file", {
        file_id: user.image.replace(/^speakid\//, ""),
      })
      .then(() => {
        axios
          .patch(Config.BACKEND_ADDR + `/auth/user/${user.id}`, {
            image: "",
          })
          .then(() => {
            dispatch(
              updateUser({
                image: undefined,
              }),
            );
            setIsWaiting(false);
          })
          .catch(() => {
            setIsWaiting(false);
          });

        //alert("Изображение профиля удалено");
      })
      .catch((e) => {
        //alert("Ошибка удаления изображения");
        setIsWaiting(false);
        console.error("Error deleting user image:", e);
      });
  }

  return (
    <React.Fragment>
      <ModalSimple
        type={modalContent.h2 === t("Ошибка загрузки") ? "error" : modalContent.type}
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        h2={modalContent.h2}
        p={modalContent.p}
        buttonText={modalContent.buttonText}
        zIndex={MODAL_Z_INDEX_NESTED}
      />

      <div
        style={{
          ...styles.profileImageUpdatingContainer,
          width: screenWidth >= 768 ? 530 : 320,
        }}
      >
        {/*Image deleting submit modal
            <ProfileImageDeletingSubmitModal
                isShown={imageDeleting}
                onRequestClose={() => setImageDeleting(false)}
                onSubmit={handleDeleteImage}
                onDecline={() => setImageDeleting(false)}
            />
            */}
        <ModalQuestion
          type="alert"
          isOpen={imageDeleting}
          onClose={(answer) => {
            if (answer) {
              handleDeleteImage();
            } else {
              setImageDeleting(false);
            }
          }}
          h2={t("Удалить фото")}
          p={t("Отменить это действие будет невозможно")}
          yesText={t("Да, удалить")}
          noText={t("Нет, не удалять")}
          isButtonRevers={false}
          zIndex={MODAL_Z_INDEX_NESTED}
        />
        {/*Image deleting button*/}
        {isWaiting && (
          <div
            style={{
              ...styles.profileImageUpdatingWaitingContainer,
              width: screenWidth >= 768 ? 530 : 320,
            }}
          >
            <InfinitySpin size={24} color={color_red_default} />

            <div style={{ color: color_red_default }}>
              {t("Подождите, идет {{action}} изображения...", { action: waitingText })}
            </div>
          </div>
        )}

        <div
          style={{ ...styles.profileImageUpdatingActionContainer }}
          onClick={() => toggleImageDeleting()}
        >
          {user.image && !isWaiting && (
            <React.Fragment>
              <div style={{ ...styles.profileImageUpdatingActionIcon }}>
                {" "}
                <DeleteIcon />{" "}
              </div>
              <Link>{t("Удалить")}</Link>
            </React.Fragment>
          )}
        </div>

        {/*Image circle*/}
        <img
          style={{ ...styles.profileImageUpdatingImageCircle }}
          src={
            user.image
              ? Config.CLOUD_ADDR + "/" + user.image
              : window.location.origin + "/no_profile_icon.png"
          }
          alt={"profileImage"}
        />

        {/*Image updating button*/}
        <div
          style={{ ...styles.profileImageUpdatingActionContainer }}
          onClick={() => uploadNewImage()}
        >
          <div style={{ ...styles.profileImageUpdatingActionIcon }}>
            {" "}
            <EditIcon fill={color_red_default} />{" "}
          </div>
          <Link>{t("Изменить")}</Link>
          <input
            accept="image/png, image/gif, image/jpeg"
            type="file"
            id="file"
            ref={inputFile}
            style={{ display: "none" }}
            onChange={(e) => imageSelectedHandler(e)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};
